'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPanel = exports.TabList = exports.Tab = exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TabPanel = require('./TabPanel');

var _TabPanel2 = _interopRequireDefault(_TabPanel);

var _TabList = require('./TabList');

var _TabList2 = _interopRequireDefault(_TabList);

var _Tab = require('./Tab');

var _Tab2 = _interopRequireDefault(_Tab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is the Main Tabs component which wraps the behaviour logic
 */
var Tabs = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Tabs, _Component);

  // static defaultProps = {
  //   children: [],
  //   selected: 0,
  // };

  function Tabs(props) {
    (0, _classCallCheck3.default)(this, Tabs);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call(this, props));

    _this._changeTab = function (event, index) {
      var _this$props = _this.props,
          onBeforeChangeTab = _this$props.onBeforeChangeTab,
          onAfterChangeTab = _this$props.onAfterChangeTab;

      var node = event.target;

      /*
        This next line might not have the intended behavior if the click event
        is registered on a child of the underlying <li> element
      */
      // const index = [].slice.call(node.parentNode.children).indexOf(node);

      if (onBeforeChangeTab && onBeforeChangeTab(event, _this.state.selectedTab, index) === false) return;

      if (node.className.indexOf('isDisabled') === -1) {
        _this.setState({ selectedTab: index }, function () {
          if (onAfterChangeTab) onAfterChangeTab(event);
        });
      }
    };

    _this.renderChildren = function () {
      var children = _this.props.children;

      var flat = _react2.default.Children.toArray(children);
      var processed = [];

      processed[0] = _react2.default.cloneElement(flat[0], {
        selected: _this.state.selectedTab,
        changeTab: _this._changeTab
      });

      processed[1] = _react2.default.cloneElement(flat[_this.state.selectedTab + 1]);

      return processed;
    };

    _this.state = { selectedTab: props.selected || 0 };
    return _this;
  }

  (0, _createClass3.default)(Tabs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var next = nextProps.selected;
      var current = this.state.selectedTab;
      this.setState({ selectedTab: next === undefined ? current : next });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChildren()
      );
    }
  }]);
  return Tabs;
}(_react.Component), _class.TabList = _TabList2.default, _class.TabPanel = _TabPanel2.default, _class.propTypes = {
  /** This prop designates which tab is selected based off its index */
  selected: _react.PropTypes.number,
  /** This is the callback which is fired before the changeTab event */
  onBeforeChangeTab: _react.PropTypes.func,
  /** This is the callback which is fired after the changeTab event */
  onAfterChangeTab: _react.PropTypes.func,
  children: _react.PropTypes.node.isRequired
}, _temp);
exports.default = Tabs;
exports.Tab = _Tab2.default;
exports.TabList = _TabList2.default;
exports.TabPanel = _TabPanel2.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTabs/Tabs.jsx
// module id = 348
// module chunks = 0